import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { services } from '../mockData';

const ServicesSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section id="services" ref={sectionRef} className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Image Side */}
          <div className={`relative overflow-hidden rounded-sm transition-all duration-1000 transform ${
            isVisible ? 'translate-x-0 opacity-100' : '-translate-x-20 opacity-0'
          }`}>
            <div className="aspect-[4/3] relative group">
              <img
                src="https://images.squarespace-cdn.com/content/v1/68ebb6751f9d04372e40f528/1dd40389-4a04-4c39-9d96-f322e19b4d5f/unsplash-image-WAm_HaI4W2E.jpg"
                alt="Massage therapy session"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </div>
          </div>

          {/* Services List */}
          <div className={`transition-all duration-1000 transform ${
            isVisible ? 'translate-x-0 opacity-100' : 'translate-x-20 opacity-0'
          }`}>
            <h2 className="text-5xl font-serif text-gray-800 mb-12">Services</h2>
            <div className="space-y-6">
              {services.map((service, index) => (
                <div
                  key={service.id}
                  className="group cursor-pointer transition-all duration-300 hover:translate-x-4"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="flex items-center justify-between py-4 border-b border-gray-200">
                    <div>
                      <h3 className="text-xl text-gray-800 group-hover:text-teal-600 transition-colors duration-300">
                        {service.name}
                      </h3>
                      <p className="text-sm text-gray-500 mt-1">{service.description}</p>
                    </div>
                    <div className="text-right">
                      <p className="text-lg font-medium text-gray-800">${service.price}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <Link
              to="/book"
              className="inline-block mt-10 bg-gray-900 hover:bg-teal-600 text-white px-8 py-4 text-sm tracking-wide transition-all duration-300 hover:scale-105 hover:shadow-xl"
            >
              Book an Appointment
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;